module.exports = __webpack_public_path__ + "img/athletics_icon_3.32a472d0.png";